import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "./components/Sidebar";
import MainContent from "./components/MainContent";
import { zenbridge } from "./api/zenbridgeClient";

const Dashboard = () => {
  const [selectedTenant, setSelectedTenant] = useState("");
  const [hasRestoredTenant, setHasRestoredTenant] = useState(false);

  const [contentData, setContentData] = useState(null);
  const [tenants, setTenants] = useState(null);
  const [loading, setLoading] = useState(false);
  const [posting, setPosting] = useState(false);

  useEffect(() => {
    const savedTenant = localStorage.getItem("selectedTenant");
    if (savedTenant) setSelectedTenant(savedTenant);
    setHasRestoredTenant(true);
  }, []);

  useEffect(() => {
    if (selectedTenant) localStorage.setItem("selectedTenant", selectedTenant);
  }, [selectedTenant]);

  const [abnormalCount, setAbnormalCount] = useState({
    tenantName: "",
    count: "",
  });

  const fetchTenants = async () => {
    try {
      const data = await zenbridge.get(
        "/event_data_validator/list_active_tenants_with_details"
      );

      if (Array.isArray(data)) {
        const sorted = data.sort((a, b) => {
          if (a.TenantId === "testing") return 1;
          if (b.TenantId === "testing") return -1;
          return (b.AbnormalCount || 0) - (a.AbnormalCount || 0);
        });
        setTenants(sorted);
        if (!selectedTenant && sorted.length > 0) {
          setSelectedTenant(sorted[0].TenantId);
        }
      } else {
        console.log("Unexpected data format", data);
        toast.error("Unexpected tenants response format");
      }
    } catch (error) {
      console.log("Error fetching tenants:", error);
      toast.error(error?.message || "Tenant fetching failed!");
    }
  };

  const getLatestValidationData = async () => {
    setLoading(true);
    try {
      const data = await zenbridge.get(
        `/event_data_validator/last_event_data_record?tenantId=${selectedTenant}`
      );
      setContentData(data);
    } catch (error) {
      toast.error(error?.message || "Unable to Fetch Latest Data");
      setContentData(null);
    } finally {
      setLoading(false);
    }
  };

  const postData = async () => {
    setPosting(true);
    try {
      await zenbridge.get(
        `/event_data_validator/event_data_evaluator?tenantId=${selectedTenant}`
      );
      setPosting(false);
    } catch (error) {
      toast.error(error?.message || "Unable to post data");
    } finally {
      setPosting(false);
    }
  };

  const refreshFunction = async () => {
    setLoading(true);
    try {
      const data = await zenbridge.get(
        `/event_data_validator/event_data_evaluator?tenantId=${selectedTenant}`
      );
      setContentData(data);
    } catch (error) {
      toast.error(error?.message || "Unable to Refresh Data");
      setContentData(null);
    } finally {
      setLoading(false);
    }
  };

  const refreshData = () => {
    refreshFunction();
    setPosting(false);
  };

  useEffect(() => {
    if (!hasRestoredTenant) return;
    fetchTenants();
    const intervalId = setInterval(() => {
      fetchTenants();
    }, 120000);
    return () => clearInterval(intervalId);
  }, [hasRestoredTenant]);

  useEffect(() => {
    if (!contentData) return;
    let count = 0;
    contentData.volumeValidation?.forEach((item) => {
      if (item.validation === "abnormal") count += 1;
    });
    contentData.workflowValidation?.workflowDataValidationResult?.forEach(
      (item) => {
        if (item.validation === "abnormal") count += 1;
      }
    );
    setAbnormalCount({ tenantName: selectedTenant, count });
  }, [contentData, selectedTenant]);

  useEffect(() => {
    if (selectedTenant) getLatestValidationData();
  }, [selectedTenant]);

  useEffect(() => {
    setContentData(null);
  }, []);

  return (
    <div className="flex">
      <Sidebar
        setSelectedTenant={setSelectedTenant}
        TenantsList={tenants}
        selectedTenant={selectedTenant}
        abnormalCount={abnormalCount}
        fetchTenants={fetchTenants}
        postData={postData}
      />
      <div className="ml-[280px] w-full">
        <MainContent
          contentData={contentData}
          refreshData={refreshData}
          selectedTenant={selectedTenant}
          loading={loading}
          posting={posting}
          sideBarInfo={tenants}
        />
      </div>
      <ToastContainer position="bottom-right" autoClose={2000} />
    </div>
  );
};

export default Dashboard;


